(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accordion-tabs')) {
  class AccordionTabs extends HTMLElement {
    connectedCallback() {
      this.multiple = this.dataset.multiple === 'true';
      this.items = Array.from(this.querySelectorAll('.hdt-acc__item'));

      this.items.forEach((item) => {
        const trigger = item.querySelector('.hdt-acc__trigger');
        if (trigger) {
          trigger.addEventListener('click', () => this.toggle(item));
        }
      });
    }

    toggle(item) {
      const isOpen = item.classList.contains('is-open');

      if (!this.multiple) {
        this.items.forEach((other) => {
          if (other !== item && other.classList.contains('is-open')) {
            this.collapse(other);
          }
        });
      }

      isOpen ? this.collapse(item) : this.expand(item);
    }

    expand(item) {
      const panel = item.querySelector('.hdt-acc__panel');
      const trigger = item.querySelector('.hdt-acc__trigger');
      if (!panel) return;

      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');

      panel.hidden = false;
      const target = panel.scrollHeight;

      const anim = panel.animate(
        [
          { height: '0px', opacity: 0 },
          { height: target + 'px', opacity: 1 }
        ],
        { duration: 360, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
      );

      anim.onfinish = () => {
        panel.style.height = 'auto';
      };
    }

    collapse(item) {
      const panel = item.querySelector('.hdt-acc__panel');
      const trigger = item.querySelector('.hdt-acc__trigger');
      if (!panel) return;

      const start = panel.scrollHeight;

      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');

      const anim = panel.animate(
        [
          { height: start + 'px', opacity: 1 },
          { height: '0px', opacity: 0 }
        ],
        { duration: 300, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
      );

      anim.onfinish = () => {
        panel.hidden = true;
        panel.style.height = '';
      };
    }
  }

  customElements.define('accordion-tabs', AccordionTabs);
}
  } catch(e) { console.error(e); }
})();

})();
